export default __webpack_public_path__ + "static/media/telegram.fac14727.png";